import {NotificationService} from "../../services/NotificationService";
import {Template} from "../../entities/Template";
import {TemplateService} from "../../services/TemplateService";
import {EditModel} from "./EditModel";
import { PrintClientService } from "../../services/PrintClientService";
import { PrintClient } from "../../entities/PrintClient";

export class EditTemplateModel extends EditModel<Template> {
    entityId: number;
    printClients: PrintClient[] = [];
    static $inject = ['$q', 'TemplateService', 'PrintClientService', 'NotificationService'];
    constructor($q: ng.IQService, service: TemplateService, public printClientService: PrintClientService, public notifyService: NotificationService) {
        super($q, service, Template);
    }
    verifyData(): ng.IPromise<boolean> {
        if (this.entity.name == null || this.entity.name.length == 0) {
            this.notifyService.notifyError("Name is required.");
            return this.$q.when<boolean>(false);
        }
        if ((this.entity.useWithService == null || this.entity.useWithService.length == 0) && this.entity.printClientID == null) {
            this.notifyService.notifyError("Use With Alarm Monitoring Service field or a Print Client is required.");
            return this.$q.when<boolean>(false);
        }
        if (this.entity.useWithService != null && this.entity.useWithService.length > 0 && this.entity.printClientID != null) {
            this.notifyService.notifyError("Please assign to Alarm Monitoring Service or Print Client, but not both.");
            return this.$q.when<boolean>(false);
        }
        return this.$q.when<boolean>(true);
    }
    loadData(entityId?: number): ng.IPromise<boolean> {
        return super.loadData(entityId).then((ok) => {
            return this.printClientService.getAllExtended().then((printClients) => {
                var emptyPrintClient = new PrintClient(null, "");
                printClients.unshift(emptyPrintClient);
                this.printClients = printClients;
                return this.$q.when<boolean>(false);
            });
        });
    }
}
